import request from 'services/axios'

/**
 * «ضمانت‌های من» — every loan the logged-in member has personally guaranteed,
 * across all their funds. Cross-fund by design: standing as a guarantor is a
 * fact about the person, not about one membership.
 */
export const getMyGuarantees = async () => {
    const { data }: { data: IMyGuarantees } = await request.get(
        '/api/v1/moneypools/my-guarantees/'
    )
    return data
}

/**
 * ضامن‌های یک وام — manager-only; the list IS the new state, [] clears it.
 *
 * `suggested` is the borrower's ضامن عضویت when they have one, offered as the
 * picker's first option. It is never auto-attached.
 */
export const getLoanGuarantors = async (
    moneypoolId: string | number,
    loanId: string | number
) => {
    const { data }: { data: ILoanGuarantorsResponse } = await request.get(
        `/api/v1/moneypools/${moneypoolId}/loans/${loanId}/guarantors/`
    )
    return data
}

export const setLoanGuarantors = async (payload: {
    moneypoolId: string | number
    loanId: string | number
    guarantor_ids: Array<number>
}) => {
    const { data } = await request.post(
        `/api/v1/moneypools/${payload.moneypoolId}/loans/${payload.loanId}/guarantors/`,
        { guarantor_ids: payload.guarantor_ids }
    )
    return data
}

/** ضامن‌ها — the fund-wide guarantor graph behind the admin dashboard tab. */
export const getGuarantorGraph = async (moneypoolId: string | number) => {
    const { data }: { data: IGuarantorGraph } = await request.get(
        `/api/v1/moneypools/${moneypoolId}/admin-dashboard/guarantors/`
    )
    return data
}
